/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Title_ShoppingInputs */

const en_title_shopping = /** @type {(inputs: Title_ShoppingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shopping list`)
};

const de_title_shopping = /** @type {(inputs: Title_ShoppingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einkaufsliste`)
};

/**
* | output |
* | --- |
* | "Shopping list" |
*
* @param {Title_ShoppingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const title_shopping = /** @type {((inputs?: Title_ShoppingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Title_ShoppingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_title_shopping(inputs)
	return en_title_shopping(inputs)
});